/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-06-09 15:49:13
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 发送验证码
export const sendCode = params => {
	return request({
		url: '/api/sms/send',
		data: params,
		method: AjaxMethod.post,
	});
};

//验证码登录
export const codeLogin = params => {
	return request({
		url: '/api/login/index',
		data: params,
		method: AjaxMethod.post,
	});
};
// 登录之后判断是否有绑定微信
export const bindWxLogin = params => {
	return request({
		url: '/api/official-account/login',
		data: params,
		method: AjaxMethod.post,
	});
};
// 校验是否绑定了微信
export const checkBindWx = params => {
	return request({
		url: '/api/official-account/check-bind',
		data: params,
		method: AjaxMethod.post,
	});
};

//验证是否绑定了密码
export const checkPass = params => {
	return request({
		url: '/api/login/check-pass-word',
		data: params,
		method: AjaxMethod.post,
	});
};

// 用户账号密码登录
export const preLogin = data => {
	return request({
		url: '/api/login/pre-login',
		data,
		method: AjaxMethod.post,
	});
};
// 用户手机验证码登录
export const preSmsLogin = data => {
	return request({
		url: '/api/official-account/pre-sms-login',
		data,
		method: AjaxMethod.post,
	});
};
// 多租户确认选择登录的租户
export const confirmLogin = data => {
	return request({
		url: '/api/official-account/login-conform',
		data,
		method: AjaxMethod.post,
	});
};

//设置密码
export const setPassword = params => {
	return request({
		url: '/api/login/set-pass-word',
		data: params,
		method: AjaxMethod.post,
	});
};

export const logout = params => {
	return request({
		url: '/api/account/logout',
		data: params,
		method: AjaxMethod.post,
	});
};

export const menuList = params => {
	return request({
		url: '/api/menu/list',
		data: params,
		method: AjaxMethod.post,
	});
};
// 用户当前正在进行的任务
export const teamCurrentTask = params => {
	return request({
		url: '/api/task/team-current-task',
		params,
		method: AjaxMethod.get,
	});
};

// 用户当前正在进行的任务
export const pollGetTaskInfo = params => {
	return request({
		url: '/api/task/repeat-query',
		params,
		method: AjaxMethod.get,
	});
};

/**
 * 检查用户当前租户是否有指定权限
 * @param {Object} params
 * @param {String} params.permission 指定权限字符串，如talentCRM:clueSeas:dyAlliance
 * */
export const checkPermission = params => {
	return request({
		url: '/api/menu/check-permission',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 商团协作短信注册友情版租户
export const loginRegister = data => {
	return request({
		url: '/api/login/register',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 注册发送验证码
export const sendRegister = params => {
	return request({
		url: '/api/sms/register',
		data: params,
		method: AjaxMethod.post,
	});
};
